import React, { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { FormControl, FormHelperText, TextField, Typography, InputLabel, Select, MenuItem, Button, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { AcquirerActions, NotificationActions } from '../../../store';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        "& h6": {
            fontSize: '12px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const acquirersSelector = (state) => state.Acquirers;
const IdentitySelector = (state) => state.Identity;

const AcquirerStepThree = (props) => {

    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const acquirerActions = bindActionCreators(AcquirerActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(acquirersSelector);
    const { token } = useSelector(IdentitySelector); 

    const { control, errors, handleSubmit, watch } = useForm();

    const { classes } = props;

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const currentState = editing;
        const { name, value } = e[0].target;

        currentState[name] = value;

        return value;
    }

    const handleNext = () => {
        props.handleNext();
    };

    const handleBack = () => {
        props.handleBack();
    };

    // 代表者生年月日
    var delegateBirthday = null;
    if (editing.delegate_birthday != null) {
        var dt = new Date(editing.delegate_birthday);
        delegateBirthday = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);
    }

    // submitボタンのアイコンとタイトルを画面に応じて変更
    var submitIcon;
    var submitTitle;
    if (props.mode == "regist") {
        // 登録時：次へ
        submitIcon = <ArrowForwardIosIcon />;
        submitTitle = <FormattedMessage id="Button.Next" />;
    }
    else {
        // 更新時：入力し内容に変更
        submitIcon = <SaveIcon />;
        submitTitle = <FormattedMessage id="Button.Update" />;
    }

    return (
        <form className={classes.form} noValidate>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Controller
                        name="delegate_name"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.delegate_name}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 50, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerDelegateNameMaxLenPattern" />}</Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.delegate_name && true}
                            helperText={errors.delegate_name ? errors.delegate_name.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 沖縄太郎</Typography>}
                            label={<FormattedMessage id={"Merchant.FullName"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="delegate_f_name"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.delegate_f_name}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 50, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerDelegateNameMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[ァ-ヶー０-９]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.KatakanaName" />}</Typography> }
                        }}
                        as={<TextField fullWidth variant="outlined"
                            error={errors.delegate_f_name && true}
                            helperText={errors.delegate_f_name ? errors.delegate_f_name.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} オキナワタロウ</Typography>}
                            label={<FormattedMessage id={"Merchant.FullNameFurigana"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="delegate_birthday"
                        control={control}
                        onChange={onChange}
                        as={<TextField fullWidth variant="outlined"
                            id="delegate_birthday"
                            label={<FormattedMessage id={"Merchant.BirthDate"} />}
                            type="date"
                            defaultValue={delegateBirthday}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />}
                    />
                </Grid>
                <Grid item xs={6}>

                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="delegate_postal_code"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.delegate_postal_code}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            minLength: { value: 7, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerDelegatePostalMinLenPattern" />}</Typography> },
                            maxLength: { value: 7, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerDelegatePostalMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[0-9]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.HankakuNumber" />}</Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.delegate_postal_code && true}
                            helperText={errors.delegate_postal_code ? errors.delegate_postal_code.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 8700823</Typography>}
                            label={<FormattedMessage id={"Merchant.PostalCode"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="delegate_address"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.delegate_address}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 100, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerDelegateAdressMaxLenPattern" />}</Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.delegate_address && true}
                            helperText={errors.delegate_address ? errors.delegate_address.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 大分県大分市東大道2丁目5番60号</Typography>}
                            label={<FormattedMessage id={"Merchant.Address"} />}
                            />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="delegate_tel"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.delegate_tel}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            minLength: { value: 10, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerDelegateTelMinLenPattern" />}</Typography> },
                            maxLength: { value: 12, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerDelegateTelMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[0-9]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.Number" />}</Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.delegate_tel && true}
                            helperText={errors.delegate_tel ? errors.delegate_tel.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 0975768181</Typography>}
                            label={<FormattedMessage id={"Merchant.PhoneNumber"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth variant="outlined" error={errors.delegate_sex && true}>
                        <InputLabel id="delegate-label-sex"><FormattedMessage id={"Merchant.Sex"} /></InputLabel>
                        <Controller
                            name="delegate_sex"
                            control={control}
                            onChange={onChange}
                            defaultValue={editing.delegate_sex}
                            as={<Select
                                labelId="delegate-label-sex"
                                id="delegate-sex"
                                label={<FormattedMessage id={"Merchant.Sex"} />}>
                                <MenuItem value={1}><FormattedMessage id={"Merchant.SexMale"} /></MenuItem>
                                <MenuItem value={2}><FormattedMessage id={"Merchant.SexFemale"} /></MenuItem>
                                </Select>} />
                        <FormHelperText>{errors.delegate_sex ? errors.delegate_sex.message : ""}</FormHelperText>
                    </FormControl>
                </Grid>

                <Grid item xs={6}>
                    <Button fullWidth variant="contained" size="medium"
                        startIcon={<ArrowBackIosIcon />}
                        onClick={handleBack}><FormattedMessage id="Button.Back" /></Button>
                </Grid>
                <Grid item xs={6}>
                    <Button fullWidth variant="contained" size="medium" color="primary"
                        onClick={handleSubmit(handleNext)}
                        endIcon={submitIcon}>
                        {submitTitle}
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}

export default withStyles(style, { withTheme: true })(AcquirerStepThree);
